import { useEffect } from 'react';
import { FilterCategory } from '../../Components/Public/Filters/FilterCategory.js';
import { CountDatas } from '../../Components/Public/Functions/CountDatas.js';
import { GetStrTotal } from '../../Components/Public/Functions/GetStrTotal.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BreadCrumb } from '../../Components/Public/Document/Breadcrumb.js';
import { BlockLogoCategories } from '../../Components/Public/Logos/BlockLogoCategories.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';

export const CategoriesFamilies = (props) => {
    const { navParks, arc, att, cha, fam, ren } = props;
    const cat = FilterCategory('home', att);
    const arch = arc ? CountDatas('category-archive', arc) : '';
    const attr = att ? CountDatas('family-attraction', att) : '';
    const cate = att ? CountDatas('category-attraction', att) : '';
    const char = cha ? CountDatas('family-personnage', cha) : '';
    const renc = ren ? CountDatas('category-rencontre', ren) : '';
    useEffect(() => {
        ScrollTop();
    }, []);
    return (
        <div className="categories">
            <Navigation navParks={navParks} />
            <Header />
            <BreadCrumb label="categories" />
            <section className="infos info-categories">
                <div className="list">
                    <div className="title-list">{`${GetStrTotal('Catégorie', cat.length)} (${cat.length})`}</div>
                    {cat.map((el, i) => {
                        let legend = [cate[el.cslug], renc[el.cslug], arch[el.cslug],`${arc.length} archives`];
                        return (
                            <BlockLogoCategories label="categories" item={el} legend={legend} key={i} />
                        )
                    })}
                </div>
            </section>
            <section className="infos info-familles">
                <div className="list">
                    <div className="title-list">{`${GetStrTotal('Famille', fam.length)} (${fam.length})`}</div>
                    {fam.map((el, i) => {
                        let legend = [attr[el.fslug], char[el.fslug]];
                        return (
                            <BlockLogoCategories label="families" item={el} legend={legend} key={i} />
                        )
                    })}
                </div>
            </section>
            <BackTop />
            <Footer />
        </div>
    )
}
